/* istanbul ignore file */
export const navigate = target =>
  window.parent.postMessage(
    JSON.stringify({
      type: 'navigate',
      payload: { route: target },
    }),
    `${window.location.protocol}//${window.location.host}`
  );
